module.exports = __webpack_public_path__ + "img/logo-v2-dark.59c84b09.svg";